import { render, staticRenderFns } from "./base-select.vue?vue&type=template&id=30242f17&scoped=true"
import script from "./base-select.vue?vue&type=script&setup=true&lang=js"
export * from "./base-select.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-select.vue?vue&type=style&index=0&id=30242f17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30242f17",
  null
  
)

export default component.exports